// extracted by mini-css-extract-plugin
module.exports = {"Btn":"LightButton_Btn__13sPO","BtnDisabled":"LightButton_BtnDisabled__2f1BX","YellowBtn":"LightButton_YellowBtn__3rHXs"};